import { takeLatest, call, put, fork } from "redux-saga/effects";
import { getProducts, createOrder, captureOrder } from "./services";
import { types } from "./constants";
import {
  getProductsSuccess,
  getProductsFail,
  createOrderSuccess,
  createOrderFail,
  captureOrderSuccess,
  captureOrderFail,
} from "./actions";
import { showSnackbar } from "../../Snackbar/store/actions";

function* getProductsSaga() {
  try {
    const { data } = yield call(getProducts);
    yield put(getProductsSuccess(data));
  } catch (error) {
    const { data = {} } = { ...error };
    const payload = {
      ...data,
      errors: { ...data.message },
    };
    yield put(getProductsFail(payload));
    yield put(
      showSnackbar({
        snackType: "error",
        snackMessage: "Failed to load products",
      })
    );
  }
}

function* createOrderSaga(action) {
  const { productName } = action.payload;
  try {
    const { data } = yield call(createOrder, productName);
    yield put(createOrderSuccess(data));
    
    // Redirect to PayPal if link is available
    if (data.link) {
      window.location.href = data.link;
    }
  } catch (error) {
    const { data = {} } = { ...error };
    const payload = {
      ...data,
      errors: { ...data.message },
    };
    yield put(createOrderFail(payload));
    yield put(
      showSnackbar({
        snackType: "error",
        snackMessage: "Failed to create order",
      })
    );
  }
}

function* captureOrderSaga(action) {
  const { orderId } = action.payload;
  try {
    const { data } = yield call(captureOrder, orderId);
    yield put(captureOrderSuccess(data));
    
    // Redirect based on status
    if (data.status === "COMPLETED") {
      window.location.href = "/pilot/payment/success";
    } else {
      window.location.href = "/pilot/payment/failed";
    }
  } catch (error) {
    const { data = {} } = { ...error };
    const payload = {
      ...data,
      errors: { ...data.message },
    };
    yield put(captureOrderFail(payload));
    window.location.href = "/pilot/payment/failed";
  }
}

function* watchGetProducts() {
  yield takeLatest(types.GET_PRODUCTS_REQUEST, getProductsSaga);
}

function* watchCreateOrder() {
  yield takeLatest(types.CREATE_ORDER_REQUEST, createOrderSaga);
}

function* watchCaptureOrder() {
  yield takeLatest(types.CAPTURE_ORDER_REQUEST, captureOrderSaga);
}

export default function* purchaseSaga() {
  yield fork(watchGetProducts);
  yield fork(watchCreateOrder);
  yield fork(watchCaptureOrder);
}
